import { FormsByTypeDTO } from '@headless-workspace/core-domain';
import { z } from 'zod';

const idFieldDTOs = [
    z.literal('title'),
    z.literal('nickname'),
    z.literal('content'),
    z.literal('received'),
    z.literal('rating'),
    z.literal('recommended'),
    z.literal('acceptedTermsAndConditions'),
    z.literal('age'),
    z.literal('usageDuration'),
];

export const FieldSchema = FormsByTypeDTO(idFieldDTOs);

export type FieldRatingAndReviews = z.infer<typeof FieldSchema.shape.fields>;

const ProductReviewDTO = z.object({
    id: z.string(),
    name: z.string(),
    imageUrl: z.string().url(),
    brand: z.object({
        name: z.string(),
    }),
});

export const RatingAndReviewsFormDTO = z.object({
    product: ProductReviewDTO,
    fields: FieldSchema.shape.fields,
});

export type RatingAndReviewsFormDTO = z.infer<typeof RatingAndReviewsFormDTO>;

export const FormDataStepTwoSchema = z.object({
    acceptedTermsAndConditions: z.literal(true),
});
